"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @react-component Sub Navigation - returns SubNav component
 */
var React = require("react");
var react_redux_1 = require("react-redux");
function SubNav(_a) {
    var content = _a.content, route = _a.route, urlList = _a.urlList, experiments = _a.experiments;
    var _b = content.subnav, subnav = _b === void 0 ? {} : _b, _c = route.enter.view, view = _c === void 0 ? "" : _c, accountTab = "", securityTab = "", paymentsTab = "", notificationsTab = "", sellerToolsTab = "", dataPrivacyTab = "";
    switch (view) {
        case "account":
            accountTab = "active";
            break;
        case "payments":
            paymentsTab = "active";
            break;
        case "security":
            securityTab = "active";
            break;
        case "notifications":
            notificationsTab = "active";
            break;
        case "seller-tools":
            sellerToolsTab = "active";
            break;
        case "data-privacy":
            dataPrivacyTab = "active";
            break;
        default:
            accountTab = "active";
    }
    var _d = experiments.factors, factors = _d === void 0 ? {} : _d;
    var _e = factors.settingsnodeweb_data_privacy, settingsnodeweb_data_privacy = _e === void 0 ? false : _e;
    return (React.createElement("div", { id: "BlueNav", className: "nav" },
        React.createElement("div", { className: "navWrapper" },
            React.createElement("ul", { role: "tablist" },
                React.createElement("li", { role: "presentation", className: "account nav-item first " + accountTab },
                    React.createElement("a", { id: "accountLink", className: "small fill-click", href: urlList.accountUrl, role: "tab", "aria-selected": accountTab === "active" ? "true" : "false", "aria-expanded": accountTab === "active" ? "true" : "false", "data-pagename": "main:walletweb:settings:profile", "data-pagename2": "main:walletweb:settings:profile:::" }, subnav.account)),
                React.createElement("li", { role: "presentation", className: "security nav-item " + securityTab },
                    React.createElement("a", { id: "securityLink", className: "small fill-click", href: urlList.securityUrl, role: "tab", "aria-selected": securityTab === "active" ? "true" : "false", "aria-expanded": securityTab === "active" ? "true" : "false", "data-pagename": "main:walletweb:settings:security", "data-pagename2": "main:walletweb:settings:security" }, subnav.security)),
                settingsnodeweb_data_privacy && (React.createElement("li", { role: "presentation", className: "data-privacy nav-item " + dataPrivacyTab },
                    React.createElement("a", { id: "dataPrivacyLink", className: "small fill-click", href: urlList.dataPrivacyUrl, role: "tab", "aria-selected": dataPrivacyTab === "active"
                            ? "true"
                            : "false", "aria-expanded": dataPrivacyTab === "active"
                            ? "true"
                            : "false", "data-pagename": "main:walletweb:settings:data-privacy", "data-pagename2": "main:walletweb:settings:data-privacy" }, subnav.dataPrivacy))),
                React.createElement("li", { role: "presentation", className: "payments nav-item " + paymentsTab },
                    React.createElement("a", { id: "paymentsLink", className: "small fill-click", href: urlList.paymentsUrl, role: "tab", "aria-selected": paymentsTab === "active" ? "true" : "false", "aria-expanded": paymentsTab === "active" ? "true" : "false", "data-pagename": "main:walletweb:settings:payments", "data-pagename2": "main:walletweb:settings:payments:::" }, subnav.payments)),
                React.createElement("li", { role: "presentation", className: "notifications nav-item " + notificationsTab },
                    React.createElement("a", { id: "notificationsLink", className: "small fill-click", href: urlList.notificationsUrl, role: "tab", "aria-selected": notificationsTab === "active" ? "true" : "false", "aria-expanded": notificationsTab === "active" ? "true" : "false", "data-pagename": "main:walletweb:settings:notifications", "data-pagename2": "main:walletweb:settings:notifications:::" }, subnav.notifications)),
                React.createElement("li", { role: "presentation", className: "seller-tools nav-item " + sellerToolsTab },
                    React.createElement("a", { id: "sellerToolsLink", className: "small fill-click", href: urlList.sellerToolsUrl, role: "tab", "aria-selected": sellerToolsTab === "active" ? "true" : "false", "aria-expanded": sellerToolsTab === "active" ? "true" : "false", "data-pagename": "main:settings:seller-tools", "data-pagename2": "main:settings:seller-tools:::" }, subnav.sellerTools))))));
}
function mapStateToProps(state, ownProps) {
    var content = state.content, route = state.route, experiments = state.experiments, urlList = {
        accountUrl: "/myaccount/settings/",
        securityUrl: "/myaccount/security",
        paymentsUrl: "/myaccount/settings/payments",
        notificationsUrl: "/myaccount/settings/notifications",
        sellerToolsUrl: "/myaccount/profile/seller-tools",
        dataPrivacyUrl: "/myaccount/privacy",
    };
    return {
        content: content,
        route: route,
        urlList: urlList,
        experiments: experiments,
    };
}
exports.default = react_redux_1.connect(mapStateToProps)(SubNav);
